import AppContainer from './components/AppContainer';

const routes = {
  '/app/team-account-setup': AppContainer,
};

export default routes;
